import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const CreateServiceMasterPage = withSuspense(lazy(() => import('./create-badges-master-page')));
export default CreateServiceMasterPage;
